import React from "react";
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";

function DialogModel(props) {
  const DialogContentHeight =
    props.height === "full"
      ? "100vh"
      : props.height === "xl"
      ? "85vh"
      : props.height === "lg"
      ? "75vh"
      : props.height === "md"
      ? "65vh"
      : "auto";

  return (
    <Dialog
      onClose={!props.disabled ? props.handleClose : () => {}}
      aria-labelledby="customized-dialog-title"
      open={props.isOpen}
      fullWidth={props.isFullWidth ?? false}
      maxWidth={props.maxWidth ?? (props.isFullWidth ? "md" : undefined)} // xl | lg | md | sm | xs && Set maxWidth to md as default if fullWidth is true
      keepMounted={props.keepMounted}
    >
      {!props.hideTitle && (
        <DialogTitle id="customized-dialog-title">
          <Typography variant="overline" display="block">
            <span className="text-dark">{props.title}</span>
          </Typography>
          <IconButton
            aria-label="close"
            onClick={props.handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>

          {props.subTitle}
        </DialogTitle>
      )}
      <DialogContent
        dividers
        className={`${props.hideFooter ? "pb-3" : ""}`}
        style={{ height: DialogContentHeight }}
      >
        {props.children}
      </DialogContent>
      {!props.hideFooter && (
        <DialogActions className={props.footerContent ? "px-3 pb-4" : "py-3"}>
          {props.footerContent}
        </DialogActions>
      )}
    </Dialog>
  );
}

export default DialogModel;
